import React from 'react';
import styles from './Label.module.scss';

interface ISteps {
  label: string;
}


const Label = (props: ISteps) => (
  <span className={styles.Label}>

    {props.label}
  </span>
);

Label.defaultProps = {};

export default React.memo(Label);
